import * as React from 'react';
import {useEffect, useState} from 'react';
import {Row} from '@flexe/ui-components';
import UserBarService, {UserBarData} from '../shared/services/UserBarService';
import {onPublicPage} from '../shared/utilities/windowLocation';
import FreshnessCounter from './FreshnessCounter';
import UserDetails from './UserDetails';
import WarehouseSelector from './WarehouseSelector';

/**
 * Do not import lodash either directly or indirectly. If you do, it will break some jquery imports
 * such as sortByNat that is used on the Item Master index page. See IAI-10217 for an example.
 */

const UserBar = ({authenticityToken}) => {
  const [userBarData, setUserBarData] = useState<UserBarData | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [errorText, setErrorText] = useState<string>(null);

  const fetchSettings = async () => {
    try {
      setIsLoading(true);
      const userBarService = new UserBarService(authenticityToken);
      const response = await userBarService.getUserBarSettings();

      if (response.data && response.data.userDetails) {
        setUserBarData(response.data);
      } else if (response.errors && response.errors.length > 0) {
        setErrorText(response.errors[0].detail);
      }
    } catch (err) {
      setErrorText('Failed to load the User Bar. Please refresh to try again.');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!onPublicPage()) {
      fetchSettings();
    }
  }, []);

  if (onPublicPage()) {
    return null;
  }

  return (
    <div className="user-bar">
      <Row height="45px" margin="0">
        {errorText && <span>{errorText}</span>}
        {!isLoading && userBarData && (
          <>
            <WarehouseSelector
              isShipper={userBarData.isShipper}
              initiallySelectedWarehouse={userBarData?.warehouseSelector?.selectedWarehouse || null}
              activeWarehouses={userBarData?.warehouseSelector?.activeWarehouses || []}
            />
            <FreshnessCounter isShipper={userBarData.isShipper} />
            <UserDetails
              userName={userBarData.userDetails.userName}
              changePasswordUrl={userBarData.userDetails.changePasswordPath}
              logoutUrl={userBarData.userDetails.logOutPath}
            />
          </>
        )}
      </Row>
    </div>
  );
};

export default UserBar;
